.spinner {
  display: inline-flex;
  flex: none;
  width: 24px;
  height: 24px;
  border-radius: var(--puts--border-radius--round);
  border: 2px solid var(--puts--color--neutral-600-12);
  border-top-color: var(--puts--color--neutral-600);
  animation: rotate 700ms linear infinite;

  &[data-size="small"] {
    width: 16px;
    height: 16px;
  }

  &[data-size="large"] {
    width: 32px;
    height: 32px;
    border-width: 3px;
  }
}

@keyframes rotate {
  to {
    transform: rotate(360deg);
  }
}

@media (prefers-reduced-motion: reduce) {
  .spinner {
    animation: none;
  }
}
